import { Lst } from "@/shared/lib/lst/lst";
import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { Filter } from "@/shared/lib/filter/filter";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { backendApi } from "../../api";
import { Source } from "../types/source";
import { CpyName } from "../types/entity-names";
import { ServiceKind } from "@bitory-gmbh/bsm";

const cpyApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    cpyCopy: build.mutation<CpyResponse, CpyRequest>({
      query: (request) => ({
        url: "/cpy/copy",
        method: "PATCH",
        body: request,
      }),
      // This is not optimal but reliable for now.
      // It may be nice to dynamically match
      // cpy.EntityName => tag.
      invalidatesTags: [
        "HtzAirHandlingUnitData",
        "HtzConfirmation",
        "HtzOrder",
        "HtzOffer",
        "HtzReport",
        "HtzWorkOrder",
        "HtzWorkOrderPosition",
        "OutboxGesecInvoice",
        "Process",
        "RltCalculation",
        "RltCertificate",
        "RltConfirmation",
        "RltContract",
        "RltDefaults",
        "RltDocumentation",
        "RltLMRA",
        "RltOffer",
        "RltOrder",
        "RltPricing",
        "RltPricingByArea",
        "RltTreatment",
        "RltWorkOrder",
        "CustomersServiceObject",
        "VbsCalculation",
        "VbsCertificate",
        "VbsConfirmation",
        "VbsContract",
        "VbsDefaults",
        "VbsDocumentation",
        "VbsLMRA",
        "VbsOffer",
        "VbsOrder",
        "VbsPricing",
        "VbsPricingByArea",
        "VbsTreatment",
        "VbsWorkOrder",
        "Textblock",
      ],
    }),
    cpySources: build.query<Lst<Source>, SourcesRequest>({
      query: (request) => ({
        url: "cpy/sources",
        method: "GET",
        params: { request: btoa(JSON.stringify(request)) },
      }),
    }),
  }),
});

export const { useCpyCopyMutation, useCpySourcesQuery } = cpyApi;

export type CpyRequest = {
  destinationEntityName: string;
  destinationId: string;
  sourceEntityName: string;
  sourceId: string;
  options?: unknown;
};

export type CpyResponse = unknown;

export type SourcesRequest = {
  destinationEntityName: CpyName;
  // SourceEntityNames allows users to optionally
  // limit the results to entities of this [EntityName].
  sourceEntityNames?: CpyName[];
  params: SourcesParams;
};

export type SourcesParams = {
  documentNumber?: string;
  name?: Filter<string>;
  createdAt?: Filter<RFC3339timestamp>;
  updatedAt?: Filter<RFC3339timestamp>;
  serviceKind?: Filter<ServiceKind>;
  process?: Filter<UUID>;
  company?: Filter<UUID>;
  branch?: Filter<UUID>;
  customer?: Filter<UUID>;
  serviceObject?: Filter<UUID>;
  immutable?: Filter<boolean>;
  orderBy?: OrdrBy<"createdAt" | "updatedAt">[];
};
